import { action, Action, computed, Computed } from 'easy-peasy'
import { StoreModel } from '.'

export interface GenericEntry {
  id: string
  archived?: boolean // Ajout de la propriété archived
}

export interface GenericModel<Entry extends GenericEntry> {
  entries: Entry[] | undefined
  loading: boolean
  error: Error | undefined
  setSubscriptionResult: Action<
    GenericModel<Entry>,
    {
      entries: Entry[] | undefined
      loading: boolean
      error: Error | undefined
    }
  >
  toggleArchived: Action<GenericModel<Entry>, string>
  getById: Computed<
    GenericModel<Entry>,
    (id: string) => Entry | undefined,
    StoreModel
  >
}

export function createModel<Entry extends GenericEntry>(): GenericModel<Entry> {
  return {
    entries: undefined,
    loading: false,
    error: undefined,

    // Actions
    setSubscriptionResult: action((state, { entries, loading, error }) => {
      state.entries = entries
      state.loading = loading
      state.error = error
    }),

    toggleArchived: action((state, id) => {
      const entry = state.entries?.find((entry) => entry.id === id)
      if (entry) {
        entry.archived = !entry.archived
      }
    }),

    // Computed
    getById: computed((state) => {
      return (id) => state.entries?.find((entry) => entry.id === id)
    }),
  }
}
